import { CanActivateFn } from '@angular/router';
import { map, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Navigate } from '@ngxs/router-plugin';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Store } from '@ngxs/store';
import {
  WwwAppState,
  WwwAppStateClearUserData,
  WwwAppStateGetUserData,
  WwwAppStateLogout,
  WwwRouteSlug,
} from '@pro-connect/shared';

export const authGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  const store = inject(Store);
  if (isPlatformServer(platformId)) {
    return of(true);
  }
  const jwtHp = document.cookie
    ?.split(';')
    ?.find((item) => item.includes('jwt_hp'))
    ?.split('=')[1];
  if (!jwtHp) {
    store.dispatch(new WwwAppStateClearUserData());
    return of(false).pipe(
      tap(() => {
        store.dispatch(new Navigate([`/${WwwRouteSlug.LOGIN}`]));
      }),
    );
  }

  const user = store.selectSnapshot(WwwAppState.user);
  if (!user) {
    return store.dispatch(new WwwAppStateGetUserData()).pipe(
      catchError((err) => {
        if (err?.status === 403) {
          store.dispatch(new WwwAppStateLogout());
        }
        store.dispatch(new Navigate([`/${WwwRouteSlug.LOGIN}`]));
        return throwError(() => err);
      }),
      map(() => true),
    );
  }
  return of(true);
};
